<h1>ADMIN OPTIONS</h1>
<p>This is where admin options will go</p>
<ul>
    <li>DELETE USERS</li>
    <li>ADD USERS</li>
    <li>DELETE FORMS</li>
</ul>
